import React from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import myBcaStep1 from "../../assets/images/tata-cara-pembayaran/mybca-1.png";
import myBcaStep2 from "../../assets/images/tata-cara-pembayaran/mybca-2.png";
import myBcaStep3 from "../../assets/images/tata-cara-pembayaran/mybca-3.png";
import myBcaStep4 from "../../assets/images/tata-cara-pembayaran/mybca-4.png";
import myBcaStep5 from "../../assets/images/tata-cara-pembayaran/mybca-5.png";
import myBcaStep6 from "../../assets/images/tata-cara-pembayaran/mybca-6.png";
import livinStep1 from "../../assets/images/tata-cara-pembayaran/livin-1.png";
import livinStep2 from "../../assets/images/tata-cara-pembayaran/livin-2.png";
import livinStep3 from "../../assets/images/tata-cara-pembayaran/livin-3.png";
import livinStep4 from "../../assets/images/tata-cara-pembayaran/livin-4.png";
import livinStep5 from "../../assets/images/tata-cara-pembayaran/livin-5.png";
import wondrStep1 from "../../assets/images/tata-cara-pembayaran/wondr-1.png";
import wondrStep2 from "../../assets/images/tata-cara-pembayaran/wondr-2.png";
import wondrStep3 from "../../assets/images/tata-cara-pembayaran/wondr-3.png";
import wondrStep4 from "../../assets/images/tata-cara-pembayaran/wondr-4.png";

function TransferMethodCallout() {
    return (
        <aside
            className="mt-3 rounded-r-lg border-l-4 border-brandBlue bg-brandBlue/5 p-4 text-sm leading-relaxed text-brandDarkGrey motion-safe:transition-colors"
            role="note"
        >
            <p>
                Pastikan menggunakan metode transfer <strong>Online</strong> (biaya Rp6.500), bukan{" "}
                <strong>BI FAST</strong> (Rp2.500) atau <strong>SKN</strong> (Rp2.900).
            </p>
        </aside>
    );
}

function StepFigure({ src, alt }) {
    return (
        <figure className="mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-brandDarkGreen/15 bg-white shadow-lg md:mx-0">
            <img src={src} alt={alt} loading="lazy" decoding="async" className="h-auto w-full" />
        </figure>
    );
}

function GuideStep({ index, children }) {
    return (
        <li className="flex flex-col gap-4 border-b border-brandDarkGreen/10 pb-8 last:border-b-0 last:pb-0 md:flex-row md:items-start md:gap-6">
            <div
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brandBlue text-sm font-bold text-white motion-safe:transition-transform motion-safe:duration-200"
                aria-hidden="true"
            >
                {index}
            </div>
            <div className="min-w-0 flex-1 space-y-4 text-base leading-relaxed text-brandDarkGrey">{children}</div>
        </li>
    );
}

const jumpLinkClass =
    "inline-flex items-center rounded-full border border-brandDarkGreen/25 bg-white/80 px-4 py-2 text-sm font-semibold text-brandDarkGreen motion-safe:transition-colors motion-safe:duration-200 hover:border-brandBlue hover:bg-brandBlue/5 hover:text-brandBlue focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue focus-visible:ring-offset-2";

export default function TataCaraPembayaran() {
    return (
        <div className="relative z-30 min-h-screen bg-main bg-cover bg-no-repeat px-4 pb-24 text-white md:px-0">
            <div className="relative top-[86px] flex max-md:top-32 min-h-[120px] items-center justify-center bg-bgBannerPage bg-contain bg-no-repeat md:top-[109px] md:bg-cover 2xl:top-[136px] lg:min-h-[300px]">
                <PageHeadline title="TATA CARA PEMBAYARAN KOSTRAD RUN 2026" />
            </div>
            <div className="relative top-36 container mx-auto w-full max-md:flex-wrap md:top-40 md:px-14 2xl:px-0 pb-36 md:pb-48 lg:mb-24 lg:pb-96 2xl:pb-44">
                <div className="mx-auto w-full max-w-3xl rounded-3xl bg-white/60 px-6 py-8 font-roboto text-brandDarkGrey shadow-sm backdrop-blur-sm md:px-10 md:py-12">
                    <p className="text-xs font-semibold uppercase tracking-wider text-brandBlue">Panduan pembayaran</p>
                    <p className="mt-2 text-base leading-relaxed">
                        Pilih aplikasi perbankan Anda, lalu ikuti langkah-langkah di bawah ini.
                    </p>

                    <nav className="mt-8 flex flex-wrap gap-3" aria-label="Lompat ke panduan per aplikasi">
                        <a href="#mybca" className={jumpLinkClass}>
                            myBCA
                        </a>
                        <a href="#livin" className={jumpLinkClass}>
                            Livin by Mandiri
                        </a>
                        <a href="#wondr" className={jumpLinkClass}>
                            Wondr by BNI
                        </a>
                    </nav>

                    <div className="mt-14 space-y-20 md:mt-16 md:space-y-24">
                        <section id="mybca" className="scroll-mt-36 md:scroll-mt-40">
                            <h2 className="border-b-2 border-brandDarkGreen/20 pb-3 text-xl font-bold uppercase tracking-wide text-brandDarkGreen md:text-2xl">
                                myBCA
                            </h2>
                            <ol className="mt-8 list-none space-y-8">
                                <GuideStep index={1}>
                                    <p>
                                        Buka aplikasi <strong>myBCA</strong> di ponsel Anda.
                                    </p>
                                </GuideStep>
                                <GuideStep index={2}>
                                    <p>
                                        Pilih menu <strong>Transfer</strong>, lalu pilih{" "}
                                        <strong>&quot;Bank Lain (Other Banks)&quot;</strong>.
                                    </p>
                                    <StepFigure
                                        src={myBcaStep1}
                                        alt="Menu utama myBCA: pilih Transfer lalu Bank Lain (Other Banks)"
                                    />
                                </GuideStep>
                                <GuideStep index={3}>
                                    <p>
                                        Klik{" "}
                                        <strong>
                                            &quot;Transfer ke rekening baru (Transfer to new beneficiary)&quot;
                                        </strong>
                                        .
                                    </p>
                                    <StepFigure
                                        src={myBcaStep2}
                                        alt="myBCA: opsi transfer ke rekening baru"
                                    />
                                    <StepFigure
                                        src={myBcaStep3}
                                        alt="myBCA: layar lanjutan transfer ke rekening baru"
                                    />
                                </GuideStep>
                                <GuideStep index={4}>
                                    <p>
                                        Pilih <strong>Bank BRI</strong> sebagai tujuan transfer.
                                    </p>
                                    <StepFigure src={myBcaStep4} alt="myBCA: memilih bank BRI sebagai tujuan" />
                                </GuideStep>
                                <GuideStep index={5}>
                                    <p>
                                        Masukkan <strong>nomor Virtual Account (VA)</strong> yang Anda dapatkan saat
                                        registrasi.
                                    </p>
                                    <StepFigure src={myBcaStep5} alt="myBCA: memasukkan nomor Virtual Account BRI" />
                                </GuideStep>
                                <GuideStep index={6}>
                                    <p>
                                        Akan muncul nama penerima <strong>&quot;BRIVA Kostrad Run&quot;</strong>.
                                    </p>
                                    <StepFigure
                                        src={myBcaStep6}
                                        alt="myBCA: konfirmasi nama penerima BRIVA Kostrad Run"
                                    />
                                </GuideStep>
                                <GuideStep index={7}>
                                    <p>Masukkan nominal pembayaran sesuai ketentuan.</p>
                                    <TransferMethodCallout />
                                </GuideStep>
                                <GuideStep index={8}>
                                    <p>Periksa kembali detail transaksi, lalu lakukan pembayaran.</p>
                                </GuideStep>
                            </ol>
                        </section>

                        <section id="livin" className="scroll-mt-36 md:scroll-mt-40">
                            <h2 className="border-b-2 border-brandDarkGreen/20 pb-3 text-xl font-bold uppercase tracking-wide text-brandDarkGreen md:text-2xl">
                                Livin by Mandiri
                            </h2>
                            <ol className="mt-8 list-none space-y-8">
                                <GuideStep index={1}>
                                    <p>
                                        Buka aplikasi <strong>Livin by Mandiri</strong> di ponsel Anda.
                                    </p>
                                </GuideStep>
                                <GuideStep index={2}>
                                    <p>
                                        Pilih menu <strong>&quot;Transfer&quot;</strong>.
                                    </p>
                                    <StepFigure src={livinStep1} alt="Livin by Mandiri: menu Transfer" />
                                </GuideStep>
                                <GuideStep index={3}>
                                    <p>
                                        Klik{" "}
                                        <strong>
                                            &quot;Transfer ke penerima baru (Transfer to new beneficiary)&quot;
                                        </strong>
                                        .
                                    </p>
                                    <StepFigure src={livinStep2} alt="Livin: opsi transfer ke penerima baru" />
                                </GuideStep>
                                <GuideStep index={4}>
                                    <p>
                                        Pilih <strong>Bank BRI</strong> sebagai tujuan transfer dan masukkan{" "}
                                        <strong>nomor Virtual Account (VA)</strong> yang Anda dapatkan saat registrasi.
                                    </p>
                                    <StepFigure
                                        src={livinStep3}
                                        alt="Livin: memilih BRI dan memasukkan nomor Virtual Account"
                                    />
                                </GuideStep>
                                <GuideStep index={5}>
                                    <p>
                                        Akan muncul nama penerima <strong>&quot;BRIVA Kostrad Run&quot;</strong>.
                                    </p>
                                    <StepFigure src={livinStep4} alt="Livin: nama penerima BRIVA Kostrad Run" />
                                </GuideStep>
                                <GuideStep index={6}>
                                    <p>Masukkan nominal pembayaran sesuai ketentuan.</p>
                                    <TransferMethodCallout />
                                    <StepFigure src={livinStep5} alt="Livin: memasukkan nominal dan metode transfer" />
                                </GuideStep>
                                <GuideStep index={7}>
                                    <p>Periksa kembali detail transaksi, lalu lakukan pembayaran.</p>
                                </GuideStep>
                            </ol>
                        </section>

                        <section id="wondr" className="scroll-mt-36 md:scroll-mt-40">
                            <h2 className="border-b-2 border-brandDarkGreen/20 pb-3 text-xl font-bold uppercase tracking-wide text-brandDarkGreen md:text-2xl">
                                Wondr by BNI
                            </h2>
                            <ol className="mt-8 list-none space-y-8">
                                <GuideStep index={1}>
                                    <p>
                                        Buka aplikasi <strong>Wondr</strong> di ponsel Anda.
                                    </p>
                                </GuideStep>
                                <GuideStep index={2}>
                                    <p>
                                        Pilih menu <strong>&quot;Transfer&quot;</strong>.
                                    </p>
                                    <StepFigure src={wondrStep1} alt="Wondr: menu Transfer" />
                                </GuideStep>
                                <GuideStep index={3}>
                                    <p>
                                        Klik <strong>&quot;Penerima Baru&quot;</strong>.
                                    </p>
                                    <StepFigure src={wondrStep2} alt="Wondr: memilih penerima baru" />
                                </GuideStep>
                                <GuideStep index={4}>
                                    <p>
                                        Pilih <strong>Bank BRI</strong> sebagai tujuan transfer dan masukkan{" "}
                                        <strong>nomor Virtual Account (VA)</strong> yang Anda dapatkan saat registrasi.
                                    </p>
                                    <StepFigure
                                        src={wondrStep3}
                                        alt="Wondr: bank BRI dan nomor Virtual Account"
                                    />
                                </GuideStep>
                                <GuideStep index={5}>
                                    <p>
                                        Akan muncul nama penerima <strong>&quot;BRIVA Kostrad Run&quot;</strong>.
                                    </p>
                                    <StepFigure src={wondrStep4} alt="Wondr: konfirmasi penerima BRIVA Kostrad Run" />
                                </GuideStep>
                                <GuideStep index={6}>
                                    <p>Masukkan nominal pembayaran sesuai ketentuan.</p>
                                    <TransferMethodCallout />
                                </GuideStep>
                                <GuideStep index={7}>
                                    <p>Periksa kembali detail transaksi, lalu lakukan pembayaran.</p>
                                </GuideStep>
                            </ol>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}
